import React, { useState, useEffect } from "react";
import { Menu, Typography, Table, Skeleton } from "antd";

import { postData,getData } from '../../config/api-connect';
import * as Styled from './style.js';

import PercentageBadge from '../../components/percentageBadge'
import moment from 'moment';
import { ArrowRightOutlined } from '@ant-design/icons';

const AcademySummary = ({ venue_id, game_type_id, month, year }) => {
  const [currentTab, setCurrentTab] = useState("batches");
  const [loading, setLoading] = useState(false)
  const [batchesData, setBatchesData] = useState([])
  const [header, setHeader] = useState([])
  const [studentData, setStudentData] = useState([])

  const handleClick = (e) => {
    setCurrentTab(e.key);
  };

  useEffect(() => {
    if(currentTab == 'batches'){
      getBatchDetails()
    }
    else if(currentTab == 'list'){
      getStudentList()
    }    
  }, [currentTab,game_type_id,month,year]);

  const getBatchDetails = () => {
    setLoading(true)
    var monthYear = month + '-' + year
    getData(`/business/get_batches_overview/?venue_id=${venue_id}&game_type_id=${game_type_id}&page=revenue&monthYear=${monthYear}`)
    .then(response =>{
      setBatchesData(response.result)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const batch_columns = [
    {
      title: 'Batch',    
      render: (_, record) => {
      const { start_time, end_time, days, multi_timings, id } = record;

      return (
        <div>
          <div>
            {
              (multi_timings && multi_timings.length > 0) ?
              <div>
                {
                  multi_timings.map(x=>(
                    <div style={{display:'flex'}}>
                      <span style={{flex:1}}>{x.day + ' : '}</span>
                      <span style={{flex:4}}>{x.start_time + ' - ' + x.end_time}</span>
                    </div>
                    ))
                }
              </div>
            :
              <div>
                <div>{days}</div>
                <div>{start_time + ' - ' + end_time}</div>
              </div>
            }
          </div>
        </div>
      );
    },
    },
    {
      title: 'Coach',
      dataIndex: 'buddy_names',
      render: (value) => {
        return(
          <div>
            {
              value.map(x=>(
                <div>{x}</div>
                ))
            }
          </div>
          )
      },

    },
    {
      title: 'Age Group',
      dataIndex: 'age_group_str',
      sorter: (a, b) => a.age_group_str.localeCompare(b.age_group_str),
      align:'center'
    },
    {
      title: 'Skill Level',
      dataIndex: 'game_level_str',
      sorter: (a, b) => a.game_level_str.localeCompare(b.game_level_str),
      align:'center'
    },
    {
      title: 'Revenue',
      sorter: (a, b) => {
        const revA = parseFloat(a.revenue_details.revenue) || 0;
        const revB = parseFloat(b.revenue_details.revenue) || 0;
        return revA - revB;
      },
      render: (_, record) => {
        const { revenue_details } = record;
        return <span>{revenue_details.revenue.toLocaleString('en-IN')}</span>;
      },
      align: 'right',

    },
    {
      title: 'Customers',
      sorter: (a, b) => {
        const custA = parseFloat(a.revenue_details.customers) || 0;
        const custB = parseFloat(b.revenue_details.customers) || 0;
        return custA - custB;
      },
      render: (_, record) => {
        const { revenue_details } = record;
        return <span>{revenue_details.customers}</span>;
      },
      align:'center'
    },

    {
      title: '',
      dataIndex: 'id',
      render: (value) => {
        return(
          <Styled.Icon target="_blank" href={`https://cm.sporthood.in/#/fixtures/${value}`}>
            <ArrowRightOutlined/>
          </Styled.Icon>
          )
      }
    },
  ]

  const  getStudentList= () => {
    setLoading(true)
    var monthYear = year + '-' + month
    getData(`/eagleeye/getTableData/?report_id=76386&venue_id=${venue_id}&date=${monthYear}&game_type_id=${game_type_id}`)
    .then(response =>{
      setHeader(response.headers)
      setStudentData(response.data)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const columns = header.map((header, index) => ({
    title: header,
    dataIndex: index.toString(),
    key: header,
    align: 'center',
    sorter: (a, b) => {
      const valA = a[index];
      const valB = b[index];

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);

      const isNumA = !isNaN(numA) && isFinite(valA);
      const isNumB = !isNaN(numB) && isFinite(valB);

      if (isNumA && isNumB) {
        return numA - numB;
      }

      // Fallback to string comparison
      const strA = (valA || '').toString().toLowerCase();
      const strB = (valB || '').toString().toLowerCase();
      return strA.localeCompare(strB);
    },

    render: (text) => (
        <span dangerouslySetInnerHTML={{ __html: text }} />
    )
  }));  

  const rowData = studentData.map((row, rowIndex) => {
      const rowObj = {};
      row.forEach((cell, cellIndex) => {
          rowObj[cellIndex] = cell;
      });
      return { key: rowIndex, ...rowObj };
  });

  return (
    <div style={{padding: 10}}>
      <Menu onClick={handleClick} selectedKeys={currentTab} mode="horizontal">
        <Menu.Item key="batches">Batches</Menu.Item>
        <Menu.Item key="list">Student List</Menu.Item>
      </Menu>

      <div style={{ marginTop: '1%' }}>
        {currentTab === "batches" ? 
          <div>
            {loading ?
              <Skeleton active paragraph={{ rows: 7 }} />
            :
              <Table
                className="drill-down-table table_container"
                rowKey="id"
                columns={batch_columns}
                dataSource={batchesData}
                pagination={{ pageSize: 20, showSizeChanger: false}}
               />
            }
          </div>
        :
          currentTab === 'list' &&
          
            loading ?
              <Skeleton active paragraph={{ rows: 7 }} />
            :
              <div>
                <div className="recordCount">{rowData.length} records</div>
                <Table
                  className="drill-down-table table_container center-pagination"
                  // tableLayout="fixed"
                  rowKey="id"
                  columns={columns} 
                  dataSource={rowData}
                  pagination={{ pageSize: 50, showSizeChanger: false}}
                 />
               </div>
        }
      </div>

    </div>
  );
};

export default AcademySummary;
